import { Country } from "react-phone-number-input";

import { getCountryName } from "../utils";

import styles from "./CountryName.module.scss";

interface CountryDialCodeProps {
  country: Country;
}

export const CountryName = ({ country }: CountryDialCodeProps) => {
  return <span className={styles.countryName}>{getCountryName(country)}</span>;
};
